/**
 * RelatedPerson schemas — guarantors, family members.
 *
 * Enum arrays are tied to fhir-model types via `satisfies`.
 */
import { z } from 'zod';
import type { UnifyRelationshipCode as FhirRelCode } from '@unify/fhir-model/resources/related-person';

/** Relationship codes (v3-RoleCode subset) — synced with fhir-model. */
export const relationshipCodeValues = [
  'PRN',
  'FTH',
  'MTH',
  'SPS',
  'GUARD',
] as const satisfies readonly FhirRelCode[];

/**
 * Create a related person linked to a patient.
 */
export const createRelatedPersonSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  firstName: z.string().trim().min(1, 'First name is required'),
  lastName: z.string().trim().min(1, 'Last name is required'),
  relationshipCode: z.enum(relationshipCodeValues, 'Relationship type is required'),
  phone: z.string().optional(),
  email: z.string().email().optional().or(z.literal('')),
});

export type CreateRelatedPersonInput = z.infer<typeof createRelatedPersonSchema>;
